import { useEffect, useState } from "react";
import { Maximize2, Minimize2 } from "lucide-react";

const hasApi = () => typeof document !== "undefined" && !!(document.documentElement.requestFullscreen || document.documentElement.webkitRequestFullscreen);
const isNative = () => !!(document.fullscreenElement || document.webkitFullscreenElement);

// Plein écran : API navigateur si disponible, sinon mode immersif (en-tête masqué) — ex. Safari iPhone.
export function useFullscreen() {
  const [active, setActive] = useState(() => isNative() || document.body.classList.contains("immersive"));
  useEffect(() => {
    const sync = () => setActive(isNative() || document.body.classList.contains("immersive"));
    document.addEventListener("fullscreenchange", sync);
    document.addEventListener("webkitfullscreenchange", sync);
    window.addEventListener("m2hat-immersive", sync);
    return () => { document.removeEventListener("fullscreenchange", sync); document.removeEventListener("webkitfullscreenchange", sync); window.removeEventListener("m2hat-immersive", sync); };
  }, []);
  const toggle = async () => {
    const el = document.documentElement;
    try {
      if (hasApi()) {
        if (isNative()) await (document.exitFullscreen || document.webkitExitFullscreen).call(document);
        else await (el.requestFullscreen || el.webkitRequestFullscreen).call(el);
        return;
      }
    } catch { /* refus navigateur → mode immersif */ }
    document.body.classList.toggle("immersive");
    window.dispatchEvent(new Event("m2hat-immersive"));
    window.scrollTo(0, 0);
  };
  return { active, immersive: active && !isNative(), toggle };
}

export const FullscreenToggle = ({ className = "" }) => {
  const { active, toggle } = useFullscreen();
  return (
    <button
      type="button"
      onClick={toggle}
      aria-label={active ? "Quitter le plein écran" : "Plein écran"}
      title={active ? "Quitter le plein écran" : "Plein écran"}
      aria-pressed={active}
      data-testid="fullscreen-toggle"
      className={`h-9 w-9 rounded-full border border-[var(--border)] bg-[var(--surface)] text-[var(--ink-soft)] hover:text-[var(--gold)] hover:border-[var(--gold)] flex items-center justify-center transition-colors ${className}`}
    >
      {active ? <Minimize2 size={16} /> : <Maximize2 size={16} />}
    </button>
  );
};
